import api from "PFCore/api";
import { Profile } from "PFTypes";

export type ResetRegistrationStatusPayload = {
  id: string;
};

export const resetRegistrationStatus = (id: string): Promise<Profile> =>
  api({
    method: "PUT",
    url: `admin/profiles/${id}`,
    data: {
      registrationStatus: "new"
    }
  });
